var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#3889FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60561 8.89594L8 10.7919V17.6407V24.4895H10.4107H12.8214V25.7448V27H14.017H15.2126L16.4174 25.7448L17.6222 24.4895H19.4137H21.2052L23.6026 21.8222L26 19.1548L26 13.0774V7H17.6056H9.21122L8.60561 8.89594ZM24.7848 13.2451L24.795 18.2558L23.1173 20.1362L21.4397 22.0167L19.3073 22.0188L17.1749 22.0209L15.9072 22.9833C15.21 23.5126 14.6282 23.9456 14.6144 23.9456C14.6006 23.9456 14.5893 23.5126 14.5893 22.9833V22.0209H12.5H10.4107V15.117V8.21318L17.5926 8.22372L24.7746 8.23431L24.7848 13.2451ZM16.3973 14.5105V17H17H17.6027V14.5105V12.0209H17H16.3973V14.5105ZM20.0134 14.5105V17H20.596H21.1786V14.5105V12.0209H20.596H20.0134V14.5105Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.718ca070.svg";
export { ForwardRef as ReactComponent };